import { MenuPath, HistoryType } from '../types';
import { Site, SLD } from '@patsnap-utils/biz';

export const createMenus = () => {
    const menus = [
        {
            id: MenuPath.HOME,
            icon: 'SolidHome',
            target: '_self',
        },
        {
            id: MenuPath.SEEK,
            icon: 'SolidSearchLeft',
            target: '',
        },
        {
            id: MenuPath.MONITOR,
            icon: 'SolidAim',
            children: [
                {
                    id: MenuPath.MONITOR_TOPIC,
                    target: '_self',
                },
                {
                    id: MenuPath.MONITOR_SUBSCRIPTION,
                    target: '_self',
                }
            ],
        },
        {
            id: MenuPath.WORKSPACE,
            icon: 'SolidNavWorkspace',
            target: '_blank',
        }
    ];

    return menus;
};

export const HISTORY_MENU_ITEM = {
    id: MenuPath.HISTORY,
    icon: 'SolidTimeRefresh',
};

export const INCOGNITO_MENU_ITEM = {
    id: MenuPath.INCOGNITO,
    icon: 'SolidSecutiry',
}

export const JUMP_PACKAGE = {
    [MenuPath.HOME]: 'home',
    [MenuPath.MONITOR_TOPIC]: 'monitor/#/topics?from=nav',
    [MenuPath.MONITOR_SUBSCRIPTION]: 'monitor/#/my?from=nav',
    [MenuPath.WORKSPACE]: new Site({ sld: SLD.WORKSPACE, pathname: '' }).href,
    [HistoryType.PATENT_DISCLOSURE]: 'ai-disclosure/#',
    [HistoryType.SEEK_SEARCH]: 'home',
    [HistoryType.TECH_MIND]: 'whiteboard/#',
    [HistoryType.MATERIAL_MIND]: 'whiteboard/#',
    [HistoryType.IDEA_EXPLORATION]: 'whiteboard/#',
    [HistoryType.TECH_RESEARCH]: 'project/#',
    [HistoryType.TECH_FMEA]: 'fmea/#',
};

export const EVENTS_CONFIG = {
    [MenuPath.HOME]: 'SS Seek Search',
    [MenuPath.SEEK]: 'SS Seek Search',
    [MenuPath.MONITOR_TOPIC]: 'SS News Letter',
    [MenuPath.MONITOR_SUBSCRIPTION]: 'SS News Letter',
    [MenuPath.INCOGNITO]: 'SS Seek Search',
    [MenuPath.WORKSPACE]: 'SS Workspace',
    [HistoryType.SEEK_SEARCH]: 'SS Seek Search',
    [HistoryType.TECH_MIND]: 'SS Idea AI',
    [HistoryType.TECH_FMEA]: 'SS Tech FMEA',
    [HistoryType.TECH_RESEARCH]: 'SS Project',
    [HistoryType.IDEA_EXPLORATION]: 'SS Idea AI',
    [HistoryType.MATERIAL_MIND]: 'SS Material Mind',
    [HistoryType.PATENT_DISCLOSURE]: 'SS Patent Disclosure',
};

export const getPath = (id: string, type: HistoryType) => {
    if (!id) return ''
    const paths = {
        [HistoryType.SEEK_SEARCH]: `/page/${id}`,
        [HistoryType.TECH_MIND]: `/chat/${id}`,
        [HistoryType.MATERIAL_MIND]: `/material/chat/${id}`,
        [HistoryType.IDEA_EXPLORATION]: `/chat/${id}`,
        [HistoryType.TECH_RESEARCH]: `/chat/${id}`,
        [HistoryType.TECH_FMEA]: `/page/${id}`,
        [HistoryType.PATENT_DISCLOSURE]: `/disclosure/${id}`,
    };
    return paths[type] || '';
};

export const SAVED_COLLAPSE_KEY = 'COMMON_NAV_COLLAPSE';

export const ROUTE_NAME_WHITELIST = ['chatDetail'];

export const getMonitorSourceToMenuPath = (source: 'my' | 'list') => {
    const paths = {
        list: MenuPath.MONITOR_TOPIC,
        my: MenuPath.MONITOR_SUBSCRIPTION,
    };
    return paths[source];
}
